import { REVIEW_STATUS } from '@/constants/reviewStatus';
import { FILTER_KEYS, parseEnumFilter, parseNumberFilter, toFilterText } from '@/utils/filters';
import { DATE_FROM_FILTER_KEY, DATE_TO_FILTER_KEY } from '@/utils/filterFields';
import { TEACHER_INACTIVATION_REASON } from '../constants/teacherInactivation.constants';
import type {
  TeacherInactivationFilterParams,
  TeacherInactivationListParams,
  TeacherInactivationSearch,
} from '../types/teacherInactivation.types';

type FilterValues = Record<string, string>;

export const REVIEW_STATUS_FILTER_KEY = 'reviewStatus';
export const REASON_FILTER_KEY = 'reasonCode';

export function toTeacherInactivationFilterValues(search: TeacherInactivationSearch): FilterValues {
  return {
    [DATE_FROM_FILTER_KEY]: toFilterText(search.dateFrom),
    [DATE_TO_FILTER_KEY]: toFilterText(search.dateTo),
    [REVIEW_STATUS_FILTER_KEY]: toFilterText(search.reviewStatus),
    [REASON_FILTER_KEY]: toFilterText(search.reasonCode),
    [FILTER_KEYS.districtId]: toFilterText(search.districtId),
    [FILTER_KEYS.thanaId]: toFilterText(search.thanaId),
    [FILTER_KEYS.amUserId]: toFilterText(search.amUserId),
    [FILTER_KEYS.zmUserId]: toFilterText(search.zmUserId),
  };
}

export function toTeacherInactivationFilterSearch(
  values: FilterValues,
): Omit<TeacherInactivationSearch, 'search'> {
  return {
    dateFrom: values[DATE_FROM_FILTER_KEY] || undefined,
    dateTo: values[DATE_TO_FILTER_KEY] || undefined,
    reviewStatus: parseEnumFilter(values[REVIEW_STATUS_FILTER_KEY], REVIEW_STATUS),
    reasonCode: parseEnumFilter(values[REASON_FILTER_KEY], TEACHER_INACTIVATION_REASON),
    districtId: parseNumberFilter(values[FILTER_KEYS.districtId]),
    thanaId: parseNumberFilter(values[FILTER_KEYS.thanaId]),
    amUserId: parseNumberFilter(values[FILTER_KEYS.amUserId]),
    zmUserId: parseNumberFilter(values[FILTER_KEYS.zmUserId]),
  };
}

export function toTeacherInactivationFilterParams(
  search: TeacherInactivationSearch,
): TeacherInactivationFilterParams {
  return {
    search: search.search,
    reasonCode: search.reasonCode,
    districtId: search.districtId,
    thanaId: search.thanaId,
    amUserId: search.amUserId,
    zmUserId: search.zmUserId,
    dateFrom: search.dateFrom,
    dateTo: search.dateTo,
  };
}

export function toTeacherInactivationListParams(
  search: TeacherInactivationSearch,
): TeacherInactivationListParams {
  return { ...toTeacherInactivationFilterParams(search), status: search.reviewStatus };
}
